import React from "react";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { JournalAnalysis } from "./JournalAnalysis";
import { JournalAnalysisData } from "../../types/journal";

interface JournalAnalysisSectionProps {
    analysis: JournalAnalysisData;
}

export const JournalAnalysisSection: React.FC<JournalAnalysisSectionProps> = ({ analysis }) => {
    const { t } = useTranslation();

    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="mt-6 p-4 sm:p-6 bg-gradient-to-r from-blue-50 to-purple-50 
        dark:from-blue-900/20 dark:to-purple-900/20 rounded-xl border 
        border-blue-100/50 dark:border-blue-800/30"
        >
            <div className="flex items-center mb-4">
                <Sparkles className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-2" />
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                    {t("journal.analysis.title")}
                </h3>
            </div>
            <JournalAnalysis analysis={analysis} />
        </motion.div>
    );
};